import { api } from "@/lib/api-client";
import type {
  PortfolioCategory,
  PortfolioCategoryInput,
  PortfolioCategoryView,
  PublicPortfolioCategory,
} from "./types";

function toView(category: PortfolioCategory): PortfolioCategoryView {
  return { ...category, isActive: category.deletedAt === null };
}

function toPayload(input: PortfolioCategoryInput) {
  return {
    name: input.name,
    slug: input.slug || undefined,
    description: input.description || null,
    sortOrder: input.sortOrder ?? 0,
  };
}

export const portfolioCategoriesApi = {
  publicList: () => api.get<PublicPortfolioCategory[]>("/categories"),
  list: async () => {
    const categories = await api.get<PortfolioCategory[]>("/categories/manage");
    return categories.map(toView);
  },
  create: async (input: PortfolioCategoryInput) => {
    const category = await api.post<PortfolioCategory>("/categories", toPayload(input));
    if (!input.isActive) {
      await api.delete<void>(`/categories/${category.id}`);
      return { ...category, deletedAt: new Date().toISOString(), isActive: false };
    }
    return toView(category);
  },
  update: async (id: string, input: PortfolioCategoryInput, wasActive: boolean) => {
    const category = await api.patch<PortfolioCategory>(`/categories/${id}`, toPayload(input));
    if (wasActive && !input.isActive) {
      await api.delete<void>(`/categories/${id}`);
      return { ...category, deletedAt: new Date().toISOString(), isActive: false };
    }
    if (!wasActive && input.isActive) {
      const restored = await api.post<PortfolioCategory>(`/categories/${id}/restore`);
      return toView(restored);
    }
    return { ...category, isActive: input.isActive };
  },
  delete: (id: string) => api.delete<void>(`/categories/${id}`),
};
